import React from "react";
import { Helmet } from "react-helmet";

export default function SEO({title = "Tribo Barber", description = "O Tribo Barber é um aplicativo que tem como objetivo oferecer uma solução para trazer as barbearias para o mundo dos aplicativos móveis", icon = null}){

	return (
		<Helmet>‍
			<title>{title}</title>‍
			<meta name="description" content={description} />
			<link rel="shortcut icon" href={icon ? icon : "/icon.png"} />

			{ /* Facebook tags */ }
			<meta property="og:title" content={title} />
			<meta property="og:description" content={description} />
			<meta property="og:image" content={icon ? icon : "/icon.png"}/>
			{ /* End Facebook tags */ }

			{ /* Twitter tags */ }
			<meta name="twitter:title" content={title} />
			<meta name="twitter:description" content={description} />
			<meta name="twitter:image" content={icon ? icon : "/icon.png"}/>        
			{ /* End Twitter tags */ }

			{/*
			<meta name="twitter:card" content="summary_large_image" />
			<meta name="twitter:site" content="@user" /> 
			<meta name="twitter:creator" content="@user" />
			<meta name="twitter:title" content="Pets - Products" />        
			<meta name="twitter:description" content="Best Products  pet" />
			<meta name="twitter:image" content="url_to_image"/>        
			<meta property="og:title" content="Pets - Products" />        
			<meta property="og:description" content="Best Product" />        
			<meta property="og:image" content="url_to_image”/>
			<meta property="og:url" content="pets.abc" />
			<meta property="og:site_name" content="Pets - Products" />
			<meta property="og:locale" content="en_US" />
			<meta property="og:type" content="article" />
			<meta property="fb:app_id" content="ID_APP_FACEBOOK" />
			*/}
		</Helmet>
	)
}